import r from './core';

const atPath = pathArray => pathArray.join('/');

export default {
  app: {
    getLocaleInformation() {
      return r.get('https://freegeoip.net/json/', {
        headers: '',
      });
    },
  },

  liftoffs: {
    validate(accessKey) {
      return r.get(atPath(['liftoffs', accessKey]));
    },

    list(accessKey) {
      return r.get(atPath(['liftoffs', accessKey, 'submissions']));
    },
    create(accessKey, info) {
      return r.post(atPath(['liftoffs', accessKey, 'submissions']), info);
    },
    update(accessKey, fileKey, info) {
      return r.put(atPath(['liftoffs', accessKey, 'submissions', fileKey]), info);
    },
    delete(accessKey, id) {
      return r.delete(atPath(['liftoffs', accessKey, 'submissions', id]));
    },
  },

  updateAccessToken(accessToken) {
    r.updateAccessToken(accessToken);
  },
  getHeader() {
    return r.getHeader();
  },
};



// WEBPACK FOOTER //
// ./src/libs/webcall/index.js